import { DropdownMenu, DropdownMenuContent, DropdownMenuTrigger } from "@radix-ui/react-dropdown-menu";
import React, { isValidElement, useEffect, useRef, useState } from "react";

/**
 * @typedef {Object} Option
 * @property {React.ReactNode} label
 * @property {React.ReactNode} icon
 * @property {string | number} value
 * @property {boolean} [disabled]
 * @property {boolean} [closeAfterClick]
 * @property {Function} [action]
 * @property {string} [className]
 */

/**
 * @param {Object} props
 * @param {string} props.dropClassName
 * @param {string} props.className
 * @param {Option[]} props.options
 * @param {React.ReactNode} props.element
 */

const ActionDropdown = ({ options, element, dropClassName, className }) => {
    const [show, setShow] = useState(false);
    
    return (
        <DropdownMenu open={show} onOpenChange={() => setShow((p) => !p)}>
            <DropdownMenuTrigger asChild className={className}>
                {React.cloneElement(element)}
            </DropdownMenuTrigger>
            <DropdownMenuContent
                className={`bg-white z-[200] h-full w-[250px] shadow-none rounded-xl overflow-hidden border border-[#E6E8F9] ${dropClassName}`}
                align="start"
            >
                {options.map(
                    ({ label, value, disabled, action, className, closeAfterClick, icon }) => (
                        <p
                            className={`font-medium text-sm py-[12px] px-[16px] cursor-pointer flex items-center gap-2 text-main rounded-lg transition-colors duration-300 ${
                                disabled && "cursor-not-allowed text-[#BCC2CC]"
                            } ${className}`}
                            onClick={(evt) => {
                                evt.stopPropagation();
                                if (!disabled) {
                                    action?.();
                                    closeAfterClick && setShow(false);
                                }
                            }}
                            key={value}
                        >
                            {icon && icon} {isValidElement(label) ? label : <>{label}</>}
                        </p>
                    )
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};

export default ActionDropdown;
